import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CategoryCard } from '../CompanyEvents/EventLibrary/style';
import { EventPointsWrapper } from '../MainEvents/styles';
import { withTranslation } from 'react-i18next';
import CreateChallengePoup from './challengeCreatePopup';
import LazyImage from './../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants';
import {
  NutritionIcon,
  LearningGrowthIcon,
  BenefitsIcon,
  StressIcon,
  HeartHealthIcon,
  DEIIcon,
  Healthicon
} from '../../utils/icons';

// Icon mapping
const categoryIconMap = {
  'nutrition': NutritionIcon,
  'fitness': LearningGrowthIcon,
  'workplace': BenefitsIcon,
  'stress': StressIcon,
  'health': HeartHealthIcon,
  'lifestyle': DEIIcon,
  'medical': Healthicon, 
};

// Background color mapping
const categoryColorMap = {
  'nutrition': '#F1F8F2',
  'fitness': '#FCF7F0',
  'workplace': '#F2F5FB',
  'stress': '#FAF5F8',
  'health': '#FCF2F3',
  'lifestyle': '#F5F6E8',
  'medical': '#FCF2F3',
};

// ✅ NEW — Border color mapping
const categoryBorderColorMap = {
  'nutrition': '#A4D6A8',
  'fitness': '#F1D8B4',
  'workplace': '#B8C6E3',
  'stress': '#E3B8CE',
  'health': '#E8A8B1',
  'lifestyle': '#D6D9A4',
  'medical': '#E8A8B1',
};

class BehaviorCategory extends Component {

  resolveIconAndColor = (category) => {
    const rawName = category?.name ?? '';
    const rawCategoryName = category?.category_name ?? '';
    const rawId = category?.id ?? '';
    const rawNewIcon = category?.new_icon ?? '';
    const rawImage = category?.image ?? '';

    const nameKey = typeof rawName === 'string' ? rawName.trim().toLowerCase() : '';
    const categoryNameKey = typeof rawCategoryName === 'string' ? rawCategoryName.trim().toLowerCase() : '';
    const idKey = String(rawId).trim().toLowerCase();

    let IconComponent = categoryIconMap[categoryNameKey] || null;
    let bgColor = categoryColorMap[categoryNameKey] || '#f2f2f2';
    let borderColor = categoryBorderColorMap[categoryNameKey] || '#DCDCDC';

    if (!IconComponent) {
      IconComponent = categoryIconMap[nameKey] || null;
      bgColor = categoryColorMap[nameKey] || bgColor;
      borderColor = categoryBorderColorMap[nameKey] || borderColor;
    }

    if (!IconComponent) {
      for (const key of Object.keys(categoryIconMap)) {
        if (nameKey.includes(key) || categoryNameKey.includes(key)) {
          IconComponent = categoryIconMap[key];
          bgColor = categoryColorMap[key] || bgColor;
          borderColor = categoryBorderColorMap[key] || borderColor;
          break;
        }
      }
    }

    if (!IconComponent) {
      IconComponent = categoryIconMap[idKey] || null;
      bgColor = categoryColorMap[idKey] || bgColor;
      borderColor = categoryBorderColorMap[idKey] || borderColor;
    }

    const fallbackIconUrl = rawNewIcon || rawImage || null;

    return { IconComponent, bgColor, borderColor, fallbackIconUrl };
  };

  // handleCategoryClick = (category) => {
  //   const { history } = this.props;
  //   const categoryName = category.category_name === "medical" ? "health" : category.category_name;

  //   if (history?.location?.pathname === "/challenges/categories") {
  //     history.push({
  //       pathname: `/challenges/behavior-categories/${categoryName}`,
  //       state: { name: category.name }
  //     });
  //   } else {
  //     history.push({
  //       pathname: `/company/challenges/behavior-categories/${categoryName}`,
  //       state: { name: category.name }
  //     });
  //   }
  // };



  handleCategoryClick = (category) => {
    window.console.log("Clicked category --- ", category);
    const { history } = this.props;
    history.push({ pathname: `/company/challenges/legacy-challenge-category/${category?.id}`, state: { categoryData: category } });
  };




  render() {
    const { wellbeingCategoriesData, t } = this.props;

    return (
      <EventPointsWrapper margin gap={'12px 8px'}>
        {Array.isArray(wellbeingCategoriesData) && wellbeingCategoriesData.length > 0 &&
          wellbeingCategoriesData.map((category, index) => {
            const { IconComponent, bgColor, borderColor, fallbackIconUrl } =
              this.resolveIconAndColor(category);

            return (
              <CategoryCard
                key={index}
                isCardRadius={'12px'}
                cardHeight='72px'
                isBorderRadius={'4px'}
                cardPadding={'12px 8px'}
                background={bgColor}
                style={{
                  border: `0.75px solid #dcdcdc`,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onClick={() => this.handleCategoryClick(category)}
              >
                <div
                  className="icon"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: `1px solid ${borderColor}`,
                    borderRadius: '6px',
                    padding: '4px',
                  }}
                >
                  {IconComponent ? (
                    <IconComponent />
                  ) : fallbackIconUrl ? (
                    <LazyImage
                      div={'icon'}
                      src={/^https?:\/\//i.test(fallbackIconUrl)
                        ? fallbackIconUrl
                        : `${ImageUrl}/${fallbackIconUrl}`}
                    />
                  ) : (
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 6,
                        background: '#EAEAEA'
                      }}
                    />
                  )}
                </div>

                <div style={{ marginLeft: 12, flex: 1 }}>
                  <div className="name" title={t(category?.category_name)}>
                    {t(category?.category_name)}
                  </div>
                  <div
                    className="challengeCount"
                    style={{
                      fontSize: '12px',
                      fontWeight: '400',
                      color: '#666',
                      lineHeight: '16px',
                      marginTop: '2px'
                    }}
                  >
                    {t(category.count)}
                  </div>
                </div>
              </CategoryCard>
            );
          })
        }

        <CreateChallengePoup />
      </EventPointsWrapper>
    );
  }
}

BehaviorCategory.propTypes = {
  history: PropTypes.object,
  wellbeingCategoriesData: PropTypes.array,
  t: PropTypes.func
};

export default withTranslation()(BehaviorCategory);
